module.exports = __webpack_public_path__ + "img/circle1blue.8c171df6.png";